/* eslint-disable @typescript-eslint/no-explicit-any */
import * as acConfigureNotificationTypes from './acConfigureNotificationTypes';
import hwaxios from '../../../rmsReduxStore/api-service/HWAxios';
import rmsStore from '../../../rmsReduxStore/rmsStore';
import { AxiosError, isAxiosError } from 'axios';
import { toast } from 'react-toastify';

const url = process.env.REACT_APP_SERVER_BASE_URL_AC;


export const fetchAcConfigureNotificationData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER,
      acConfigureNotificationTableLoader: true,
    };
    dispatch(loaderStartAction);
    const searchHash = reqBody?.searchTerm;
    const hashAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_NOTIFICATION_LIST_REQUEST_HASH,
      acConfigureNotificationListRequestHash: searchHash,
    };
    dispatch(hashAction);
    const response = await hwaxios.post(url + '/alarm-notification/list', reqBody);
    if (searchHash === rmsStore.getState().acConfigureNotificationReducer.acConfigureNotificationListRequestHash) {
      const action: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATIONS,
        acConfigureNotification: response.data?.data?.response,
        acConfigureNotificationCount: response.data?.data?.count,
      };
      dispatch(action);
    }
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER,
        acConfigureNotificationTableLoader: false,
      };
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER,
      acConfigureNotificationTableLoader: false,
    };
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
};

export const setAcAlarmRuleStatus: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_STATUS_LOADER,
      acConfigureNotificationTableLoader: true,
    };
    dispatch(loaderStartAction);
    const response = await hwaxios.put(url + '/alarm-notification/status', reqBody);
    const action: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_RULE_STATUS,
    };
    dispatch(action);
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_STATUS_LOADER,
        acConfigureNotificationTableLoader: false,
      };
      dispatch(loaderEndAction);
      toast.success(`Notification ${response.data.data.status}`);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_STATUS_LOADER,
      acConfigureNotificationTableLoader: false,
    };
    dispatch(loaderEndAction);
    console.error(error);
    if (error instanceof AxiosError) {
      if (error.response) {
        toast.error(error.response.data);
      }
    }
  }
};

export const setAcConfigurationNotificationListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  const action: Partial<AcConfigureNotificationAction> = {
    type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LIST_TABLE_PROPS,
    acConfigureNotificationListTableProps: data,
  };
  dispatch(action);
};

export const createAcAlarmRule: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => any): Promise<any> => {
  try {
    const searchHash = reqBody?.searchTerm;
    const hashAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_NOTIFICATION_LIST_REQUEST_HASH,
      acConfigureNotificationListRequestHash: searchHash,
    };
    dispatch(hashAction);
    const response = await hwaxios.post(url + '/alarm-notification', reqBody);
    if (searchHash === rmsStore.getState().acConfigureNotificationReducer.acConfigureNotificationListRequestHash) {
      const action: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.CREATE_AC_NEW_RULE,
      };
      dispatch(action);
    }
    return response;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response) {
        toast.error(error.response.data);
      }
    }
  }
};

export const updateAcAlarmRule: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => any): Promise<any> => {
  try {
    const searchHash = reqBody?.searchTerm;
    const hashAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_NOTIFICATION_LIST_REQUEST_HASH,
      acConfigureNotificationListRequestHash: searchHash,
    };
    dispatch(hashAction);
    const response = await hwaxios.put(url + '/alarm-notification', reqBody);
    if (searchHash === rmsStore.getState().acConfigureNotificationReducer.acConfigureNotificationListRequestHash) {
      const action: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.EDIT_AC_NEW_RULE,
      };
      dispatch(action);
    }
    return response;
  } catch (error) {
    if (error instanceof AxiosError) {
      if (error.response) {
        console.log(error.response);
        toast.error(error.response.data);
      }
    }
  }
};

export const fetchAcSingleRule: any = (reqBody: any, id: string) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => any): Promise<any> => {
  try {
    const searchHash = reqBody?.searchTerm;
    const hashAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_NOTIFICATION_LIST_REQUEST_HASH,
      acConfigureNotificationListRequestHash: searchHash,
    };
    dispatch(hashAction);
    const response = await hwaxios.get(url + `/alarm-notification?id=${id}`, reqBody);
    if (searchHash === rmsStore.getState().acConfigureNotificationReducer.acConfigureNotificationListRequestHash) {
      const action: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.FETCH_AC_RULE_FOR_EDIT,
        acIndividualAlarmDetails: response?.data?.data,
      };
      dispatch(action);
    }
    return response;
  } catch (error) {
    console.error(error);
    if (error instanceof AxiosError) {
      if (error.response) {
        toast.error(error.response.data);
      }
    }
  }
};

export const deleteAcConfigureNotification: any = (id: string) => async () => {
  try {
    const { data, status } = await hwaxios.delete(url + `/alarm-notification?id=${id}`);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return { data: 'Something went wrong', status: 400 };
    }
  }
};

export const fetchAcConfigureNotificationHistoryData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER,
      acConfigureNotificationTableLoader: true,
    };
    dispatch(loaderStartAction);
    const searchHash = reqBody?.searchTerm;
    const hashAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_NOTIFICATION_HISTORY_LIST_REQUEST_HASH,
      acConfigureNotificationHistoryListRequestHash: searchHash,
    };
    dispatch(hashAction);
    const response = await hwaxios.post(url + '/alarm-notification/history', reqBody);
    if (searchHash === rmsStore.getState().acConfigureNotificationReducer.acConfigureNotificationHistoryListRequestHash) {
      const action: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATIONS_HISTORY,
        acConfigureNotificationHistory: response.data?.data?.response,
        acConfigureNotificationHistoryCount: response.data?.data?.count,
      };
      dispatch(action);
    }
    if (response?.status === 200) {
      const loaderEndAction: Partial<AcConfigureNotificationAction> = {
        type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER,
        acConfigureNotificationTableLoader: false,
      };
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_LOADER,
      acConfigureNotificationTableLoader: false,
    };
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
};

export const setAcConfigurationNotificationHistoryListTableProps: any = (data) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  const action: Partial<AcConfigureNotificationAction> = {
    type: acConfigureNotificationTypes.SET_AC_CONFIGURE_NOTIFICATION_HISTORY_LIST_TABLE_PROPS,
    acConfigureNotificationHistoryListTableProps: data,
  };
  dispatch(action);
};

export const fetchAcNotificationHistoryTimelineData: any = (reqBody: any) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  try {
    const response = await hwaxios.post(url + '/alarm-notification/timeline', reqBody);
    const action: Partial<AcConfigureNotificationAction> = {
      type: acConfigureNotificationTypes.FETCH_AC_CONFIGURE_NOTIFICATION_HISTORY_TIMELINE,
      acConfigureNotificationHistoryTimeline: response.data?.data,
    };
    dispatch(action);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchAcNotificationTemplate = async (notificationId: string) => {
  try {
    const response = await hwaxios.get(url + `/alarm-notification/history/preview?id=${notificationId}`);
    if (response?.status === 200 || response?.status === 201) {
      return { status: 'SUCCESS', data: response?.data?.data };
    }
  } catch (error) {
    return { status: 'FAILURE' };
  }
};

export const setAcLatestConfigurationOnTop: any = (data) => async (dispatch: (arg0: Partial<AcConfigureNotificationAction>) => void): Promise<void> => {
  const action: Partial<AcConfigureNotificationAction> = {
    type: acConfigureNotificationTypes.SET_AC_LATEST_CONFIGURATION_ON_TOP,
    acGetLatestConfigurationOnTop: data,
  };
  dispatch(action);
};

export const exportAcNotificationHistoryData: any = (reqParams) => async (): Promise<unknown> => {
  try {
    const { data, status } = await hwaxios.post(url + '/alarm-notification/history/export', reqParams);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return { data: 'Something went wrong', status: 400 };
    }
  }
};
